import { useCallback, useState } from 'react';

import {
  getLoyalty2_0Category,
  getLoyalty2_0OnboardingQuickSelectTier,
  getLoyalty2_0Tier
} from 'remote/api/loyalty';
import { ILoyaltyCardBarcodeDetails } from 'state/loyalty/types';
import { Query } from 'state/network/hook';
import { ILogger } from 'utils/logger';

export interface ILoyalty {
  isAuthenticated(): boolean;
  query: Query;
  logger: ILogger;
}

const DEFAULT_BARCODE_DETAILS: ILoyaltyCardBarcodeDetails = {
  availableRedemptions: 0,
  canRedeemReward: false,
  numberOfTransactionsInTimePeriod: 0,
  numberOfTransactionsMadeTowardsNextReward: 0,
  numberOfTransactionsNeeded: 0
};

export const useDeprecatedLoyalty = ({ query, logger }: ILoyalty) => {
  const [loyaltyBarcodeDetails, setLoyaltyBarcodeDetails] = useState<ILoyaltyCardBarcodeDetails>(
    DEFAULT_BARCODE_DETAILS
  );

  const getLoyaltyCategory = useCallback(() => {
    return query(getLoyalty2_0Category())
      .then(result => {
        if (result) {
          return result;
        }

        return null;
      })
      .catch((err: Error) => {
        logger.error({
          message: `Error getting loyalty card categories`,
          error: err
        });
      });
  }, [logger, query]);

  const getLoyaltyTier = useCallback(() => {
    return query(getLoyalty2_0Tier())
      .then(result => {
        if (result) {
          return result;
        }

        return null;
      })
      .catch((err: Error) => {
        logger.error({
          message: `Error getting loyalty tier`,
          error: err
        });
      });
  }, [logger, query]);

  const getLoyaltyOnboardingQuickSelectTier = useCallback(() => {
    return query(getLoyalty2_0OnboardingQuickSelectTier())
      .then(result => {
        if (result) {
          return result;
        }

        return null;
      })
      .catch((err: Error) => {
        logger.error({
          message: `Error getting loyalty onboarding quick select tier`,
          error: err
        });
      });
  }, [logger, query]);

  return {
    loyaltyBarcodeDetails: loyaltyBarcodeDetails || DEFAULT_BARCODE_DETAILS,
    setLoyaltyBarcodeDetails,
    getLoyaltyCategory,
    getLoyaltyTier,
    getLoyaltyOnboardingQuickSelectTier
  };
};
